import React from 'react'
import PropTypes from 'prop-types'
import { appointmentsByDate, hourFromMinutes, minutesFromTime } from 'lib/helper'
import { AppointmentStatus } from 'lib/constants'
import './style.css'

import Popover from 'material-ui/Popover'
import FontAwesome from 'react-fontawesome'
import CreateOrCancelAllDialog from 'components/CreateOrCancelAllDialog'
import AppointmentCard from 'components/AppointmentCard'

class TimeslotWeeklyView extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      selectedAppointment: null,
      operations: [],
      isPopoverOpen: false,
      popoverAnchorElement: null,
      isDialogOpen: false,
      isCreationOperation: null,
      day: null,
    }
    this.appointmentSelected = this.appointmentSelected.bind(this)
    this.closePopover = this.closePopover.bind(this)
    // this.operationSelected = this.operationSelected.bind(this)
    this.closeDialog = this.closeDialog.bind(this)
    this.confirmCreate = this.confirmCreate.bind(this)
    this.confirmCloseAll = this.confirmCloseAll.bind(this)
    this.onCreateForDay = this.onCreateForDay.bind(this)
    this.onCloseAllForDay = this.onCloseAllForDay.bind(this)
  }

  appointmentSelected(selectedAppointment, e) {
    // Save selected appointment
    this.setState({ selectedAppointment })

    const { appointmentStatus } = selectedAppointment
    const { onAppointmentOpen, onAppointmentClose } = this.props
    // If open or close, do a simple toggle
    if (appointmentStatus === AppointmentStatus.Available) onAppointmentClose(selectedAppointment)
    else if (appointmentStatus === AppointmentStatus.Closed) onAppointmentOpen(selectedAppointment)

    // If not, show the dialog with options
    else {
      this.setState({
        popoverAnchorElement: e.currentTarget,
        isPopoverOpen: true
      })
    }
  }

  closePopover() {
    this.setState({ isPopoverOpen: false })
  }
  closeDialog() {
    this.setState({ isDialogOpen: false })
  }
  confirmCreate(day) {
    this.setState({ isDialogOpen: true, isCreationOperation: true, day })
  }
  confirmCloseAll(day, appointments) {
    this.setState({ isDialogOpen: true, isCreationOperation: false, day })
  }
  onCreateForDay(time) {
    const minutes = minutesFromTime(time)
    const { onAppointmentCreateForDay } = this.props
    const { day } = this.state
    onAppointmentCreateForDay(day.fullDate, minutes)
    this.closeDialog()
  }
  onCloseAllForDay() {
    const { onAppointmentCloseAllForDay } = this.props
    const { day } = this.state
    onAppointmentCloseAllForDay(day.fullDate)
    this.closeDialog()
  }

  render() {
    const { appointments, startDate, onAppointmentStart, onAppointmentOpen, onAppointmentClose, onAppointmentComplete, onAppointmentCancel, ui } = this.props
    const { selectedAppointment, isPopoverOpen, popoverAnchorElement, isDialogOpen, isCreationOperation, day } = this.state


    let appointmentsByDay = []
    if (startDate && appointments) {
      appointmentsByDay = appointmentsByDate(appointments, startDate)
    }

    return (
      <div>
        <div className="TimeslotWeeklyView">
          {appointmentsByDay.map((apd, i) => (
            <DaySlots
              day={apd.day} key={i}
              appointments={apd.appointments}
              onTimeslotSelect={this.appointmentSelected}
              onCreate={this.confirmCreate}
              onCloseAll={this.confirmCloseAll}
              ui={ui}
            />
          ))}
        </div>
        <Popover
          open={isPopoverOpen}
          anchorEl={popoverAnchorElement}
          anchorOrigin={{ horizontal: 'middle', vertical: 'bottom' }}
          targetOrigin={{ horizontal: 'left', vertical: 'top' }}
          onRequestClose={this.closePopover}>
          {selectedAppointment ?
            <AppointmentCard
              appointment={selectedAppointment}
              onOpen={appointment => { this.closePopover(); onAppointmentOpen(appointment) }}
              onClose={appointment => { this.closePopover(); onAppointmentClose(appointment) }}
              onStart={appointment => { this.closePopover(); onAppointmentStart(appointment) }}
              onComplete={appointment => { this.closePopover(); onAppointmentComplete(appointment) }}
              onCancel={appointment => { this.closePopover(); onAppointmentCancel(appointment) }}
            />
            : null}
        </Popover>

        {/* Create / Cancel Dialog */}
        <CreateOrCancelAllDialog
          isOpen={isDialogOpen}
          isCreationOperation={isCreationOperation}
          day={day}
          onCloseAll={this.onCloseAllForDay}
          onCreate={this.onCreateForDay}
          onCancel={this.closeDialog}
        />

      </div>
    )
  }
}

TimeslotWeeklyView.propTypes = {
  appointments: PropTypes.array.isRequired,
  startDate: PropTypes.object,
  onAppointmentOpen: PropTypes.func.isRequired,
  onAppointmentClose: PropTypes.func.isRequired,
  onAppointmentComplete: PropTypes.func.isRequired,
  onAppointmentCancel: PropTypes.func.isRequired,
  onAppointmentCreateForDay: PropTypes.func.isRequired,
  onAppointmentCloseAllForDay: PropTypes.func.isRequired,
  ui: PropTypes.object.isRequired,
}
export default TimeslotWeeklyView

// ---
// ---

const DaySlots = ({ day, appointments, onTimeslotSelect, onCreate, onCloseAll, ui }) => (
  <div className="DaySlots">
    <div className="Day">
      <span>{day.name}, {day.date}</span>

      <div className="OptionMenu">
        <FontAwesome name="plus-circle" size="lg" title="Criar um Horário"
          onClick={onCreate.bind(null, day)}
        />
        <FontAwesome name="times-circle" size="lg" title="Fechar Todos os Horários"
          onClick={onCloseAll.bind(null, day)}
        />
      </div>

    </div>
    <div className="Slots">
      {appointments.map(a => (
        <Timeslot
          key={a.appointmentId}
          id={a.appointmentId}
          time={hourFromMinutes(a.appointmentTime)}
          status={a.appointmentStatus}
          onSelect={onTimeslotSelect.bind(null, a)}
          ui={ui}
        />
      ))}
    </div>
  </div>
)
DaySlots.propTypes = {
  day: PropTypes.object.isRequired,
  appointments: PropTypes.array.isRequired,
  onTimeslotSelect: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  onCloseAll: PropTypes.func.isRequired,
}

const Timeslot = ({ id, time, status, onSelect, ui }) => {
  const loading = ui.timeslots[id] && ui.timeslots[id].isLoading
  return (
    <div className={`Timeslot ${status} ${loading ? 'loading' : ''}`} onClick={loading ? null : onSelect}>
      {loading ? <FontAwesome name="cog" spin size="lg" /> : <span>{time}</span>}
    </div>
  )
}
Timeslot.propTypes = {
  time: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/TimeslotWeeklyView/index.js